import React from 'react';
import './buttonLink.css';

const ButtonLink = ({ text, onClick, disabled = false }) => {
    return (
        <button
            type="button"
            className={`button-link ${disabled ? 'button-link--disabled' : ''}`}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
        >
            <span className="button-link-arrow" aria-hidden="true">←</span>
            <span className="button-link-text">{text}</span>
        </button>
    );
};

export default ButtonLink;

